import type { DigitalAdContent } from '../../../../bridge/types/artifact.ts';

/**
 * The name a customer would use for an ad.
 *
 * They read it off the image, so the in-image headline comes first. Ads created
 * before that field was persisted only carry the Meta Ads copy headline, which
 * is the closest thing to a name available for them. Capped like the other row
 * labels so a long one can't blow out the row.
 */
export const digitalAdTitle = (
	content: DigitalAdContent,
	fallback: string,
): string => {
	// Trim before choosing, not after: a headline that is only whitespace is no
	// name at all and must fall through rather than win and leave a blank row.
	const name = content.image_headline?.trim() || content.headline?.trim();
	return name?.slice(0, 80) || fallback;
};
